module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-2.2900e78e.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-2.png
// module id = 192
// module chunks = 0